import { apiFetch } from "../api";
import {BASE_URL as u} from "../../commonUrls";

const BASE_URL = `${u}/planner`;

/* -------- COLLECTION -------- */

export const getAllItems = async () => {
  const res = await apiFetch(`${BASE_URL}/all`);
  return res.json();
};

/* -------- SINGLE RESOURCE -------- */

export const getItemById = async (id) => {
  const res = await apiFetch(`${BASE_URL}/${id}`);
  return res.json();
};

/* -------- CREATE -------- */

export const createItem = async (data) => {
  const res = await apiFetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify(data)
  });
  return res.json();
};

/* -------- UPDATE -------- */

export const updateItem = async (id, data) => {
  const res = await apiFetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    body: JSON.stringify(data)
  });
  return res.json();
};

/* -------- DELETE -------- */

export const deleteItem = async (id) => {
  await apiFetch(`${BASE_URL}/${id}`, { method: "DELETE" });
};
